import { render, staticRenderFns } from "./MedicationCollapseTemplate.vue?vue&type=template&id=0d7cd686&scoped=true&"
import script from "./MedicationCollapseTemplate.vue?vue&type=script&lang=ts&"
export * from "./MedicationCollapseTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationCollapseTemplate.vue?vue&type=style&index=0&id=0d7cd686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7cd686",
  null
  
)

export default component.exports